<dx-scroll-view height="100%" width="100%" class="with-footer single-card">
  <div class="content-block dx-card responsive-paddings">
    <table class="">
      <tbody>
        <tr><td colspan="3">Data : <b>{{registration.dataRegistrazione  | date:'dd/MM/yyyy' }}</b></td></tr>
        @if (registration.inizio) {
        <tr><td colspan="3">Inizio : <b>{{registration.inizio| slice:11:16}}</b></td></tr>
        }
        @if (registration.fine) {
        <tr><td colspan="3">Fine : <b>{{registration.fine| slice:11:16}}</b></td></tr>
        }
        <tr><td colspan="3">Cantiere : <b>{{registration.descrizioneCantiere}}</b></td></tr>

        @if(!registration.allSelectedPhases?.length){
        @if (registration.fase) {
        <tr><td colspan="3">Fase : <b>{{registration.descrizioneFase}}</b></td></tr>
        }
        }

        @if (registration.costo) {
        <tr><td colspan="3">Costo : <b>{{registration.descrizioneCosto}}</b></td></tr>
        }

        <!-- se è stato dichiarato un titolo per le note 1 allora farà vedere quello
  altrimenti mostra un titolo di default  "Note" -->
        @if (registration.notes && option.descriptionNotes1) {
        <tr><td colspan="3"><b>Note -- {{option.descriptionNotes1}}</b></td></tr>
        }
        @if(registration.notes && !option.descriptionNotes1){
        <tr><td colspan="3"><b>Note</b></td></tr>
        }
        @if (registration.notes) {
        <tr><td colspan="3">{{registration.notes}}</td></tr>
        }

        <tr><td colspan="3"></td></tr>


        <!--  SUDDIVISIONE VERSIONE SCHERMATA IN CASO DI FASI MULTIPLE OPPURE NO -->
        @if(registration.allSelectedPhases?.length){

        <!-- ciclo sulle fasi salvate nella registrazione -->
        @for( fase of registration.allSelectedPhases; track fase){
        <tr><td colspan="3">Fase : <b>{{fase.constructionPhaseDescription}}</b></td></tr>


        <tr><td colspan="3"><b>Dipendenti</b></td></tr>
        <app-worker-details [workerRegistrations]="registration.workerRegistrations"
                            [currentPhaseCode]="fase.constructionPhaseCode"
                            [option]="option">
        </app-worker-details>





        <!--

  @if (registration.workerRegistrations && registration.workerRegistrations.length) {
  <tr><td colspan="3"><b>Dipendenti</b></td></tr>
  }
  @for (item of registration.workerRegistrations; track item) {
  @if( item.phaseCode == fase.constructionPhaseCode){
  <tr>
    <td></td>
    <td>{{item.workerDescription}}</td>
    <td align="right">{{item.oreLavorate}}</td>
  </tr>
  }
  }

  -->
        @if (registration.workerKilometers && registration.workerKilometers.length) {
        <tr><td colspan="3"><b>"3Chi guidab></b></td></tr>
        }
        @for (item of registration.workerKilometers; track item) {
        <tr>
          <td></td>
          <td>{{item.workerDescription}}</td>
          <td align="right">{{item.km}} Km</td>
        </tr>
        }

        <!--
  @if (registration.toolRegistrations && registration.toolRegistrations.length) {
  <tr><td colspan="3"><b>Mezzi</b></td></tr>
  }
    -->
        <tr><td colspan="3"></td></tr>  <!--  serve per spaziare e per riordinare la schermata !! -->

        <app-tool-details [toolRegistrations]="registration.toolRegistrations"
                          [currentPhaseCode]="fase.constructionPhaseCode">
        </app-tool-details>




        <!--
  @for (item of registration.toolRegistrations; track item) {
  @if( item.phaseCode == fase.constructionPhaseCode){
  <tr>
    <td></td>
    <td>{{item.toolDescription}}</td>
    <td align="right">{{item.oreLavorate}}</td>
  </tr>
  }
  }
        -->



        <tr><td colspan="3"></td></tr> <!-- righe vuote per fare da spaziatura tra un blocco e l'altro -->
        <tr><td colspan="3"></td></tr>

        <!-- fine cilco di 1 fase -->
        }
        }
        @else
        {

        @if (registration.workerRegistrations && registration.workerRegistrations.length) {
        <tr><td colspan="3"><b>Dipendenti</b></td></tr>
        }

        @for (item of registration.workerRegistrations; track item) {
        <tr>
          <td></td>
          <td>{{item.workerDescription}}</td>
          <td align="right">{{item.oreLavorate}}</td>
        </tr>
        }

        @if (registration.workerKilometers && registration.workerKilometers.length) {
        <tr><td colspan="3"><b>Chi guida</b></td></tr>
        }
        @for (item of registration.workerKilometers; track item) {
        <tr>
          <td></td>
          <td>{{item.workerDescription}}</td>
          <td align="right">{{item.km}} Km</td>
        </tr>
        }

        @if (registration.toolRegistrations && registration.toolRegistrations.length) {
        <tr><td colspan="3"><b>Mezzi</b></td></tr>
        }

        @for (item of registration.toolRegistrations; track item) {
        <tr>
          <td></td>
          <td>{{item.toolDescription}}</td>
          <td align="right">{{item.oreLavorate}}</td>
        </tr>
        }


        }

        <!--  FINE SUDDIVISIONE PAGINE  -->
        @if (registration.controlsRegistration?.length) {
        <tr><td colspan="3"><b>Controlli</b></td></tr>

        @for (item of registration.controlsRegistration; track item) {
        <tr>
          <td></td>
          <td>{{item.description}}</td>
          <td align="right">{{item.checkedV}}</td>
        </tr>
        }

        <tr>
          <td colspan="3"><b>Note dei Controlli</b></td>
        </tr>
        <tr>
          <td colspan="3">{{registration.noteControlli}}</td>
        </tr>
        }


        @if (registration.notes2) {
        <tr>
          <td colspan="3"><b>{{option.descriptionNotes2}}</b></td>
        </tr>
        <tr><td colspan="3">{{registration.notes2}}</td></tr>
        }
        @if (registration.notes3) {
        <tr>
          <td colspan="3"><b>{{option.descriptionNotes3}}</b></td>
        </tr>
        <tr><td colspan="3">{{registration.notes3}}</td></tr>
        }
        @if (registration.notes4) {
        <tr>
          <td colspan="3"><b>{{option.descriptionNotes4}}</b></td>
        </tr>
        <tr><td colspan="3">{{registration.notes4}}</td></tr>
        }




        @if (registration.attachments && registration.attachments.length) {
        <tr><td colspan="3"><b>Allegati</b></td></tr>
        <tr>
          <td colspan="3">
            <dx-gallery [dataSource]="galleryDataSource"
                        [height]="300">
            </dx-gallery>
        </tr>
        @for (item of registration.attachments; track item) {
        <tr>
          <td></td>
          <td colspan="2">{{item}}</td>
        </tr>
        }
        }


      </tbody>
    </table>
  </div>
</dx-scroll-view>
